import configureStore from './configureStore';

const store = configureStore();

export function bindActionToRedux(action, ...args) {
    return async () => {
        await action(...args)(store.dispatch, store.getState);
    };
}

 //eslint-disable-line no-process-env
window.store = store;


export default store;
